import { render, staticRenderFns } from "./SpendingProgressBar.vue?vue&type=template&id=bffc652a&scoped=true&"
import script from "./SpendingProgressBar.vue?vue&type=script&lang=js&"
export * from "./SpendingProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./SpendingProgressBar.vue?vue&type=style&index=0&id=bffc652a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffc652a",
  null
  
)

export default component.exports